import { css } from '@emotion/react';

export const sectionTabsCSS = () => css`
    margin-bottom: 12px;
    font-family: var(--pei-font);

    .st-tablist {
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 6px;
        background: #fff;
        border: 1px solid #E7E7E7;
        border-radius: 14px;
        overflow-x: auto;
        scroll-snap-type: x proximity;
        scrollbar-width: thin;
        scrollbar-color: var(--pei-line-strong) transparent;

        &::-webkit-scrollbar {
            height: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: var(--pei-line-strong);
            border-radius: 3px;
        }
    }

    .st-tab {
        flex-shrink: 0;
        scroll-snap-align: start;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 8px 14px;
        border: none;
        background: transparent;
        color: var(--pei-text-helper);
        border-radius: 10px;
        font-size: 13px;
        font-weight: 500;
        font-family: inherit;
        cursor: pointer;
        white-space: nowrap;
        transition: background 120ms ease, color 120ms ease;

        i {
            font-size: 14px;
        }

        &:hover:not(.is-current) {
            background: var(--pei-bg-soft);
        }

        &.is-current {
            background: rgba(50, 184, 223, 0.10);
            color: var(--pei-cyan);
        }

        &:focus-visible {
            outline: none;
            box-shadow: 0 0 0 2px rgba(52, 198, 241, 0.25);
        }
    }

    /* Botón destacado: descarga del reporte de Buró de Crédito */
    .st-tab--download {
        position: relative;
        margin-left: 14px;
        background: #23b56e;
        color: #fff;
        font-weight: 600;
        box-shadow: 0 1px 3px rgba(35, 181, 110, 0.35);

        &:hover:not(:disabled) {
            background: #1e9d5f;
            color: #fff;
        }

        &:disabled {
            opacity: 0.65;
            cursor: progress;
        }

        &:focus-visible {
            box-shadow: 0 0 0 2px rgba(35, 181, 110, 0.35);
        }

        /* separador respecto a las pestañas */
        &::before {
            content: '';
            position: absolute;
            left: -8px;
            top: 6px;
            bottom: 6px;
            width: 1px;
            background: #E7E7E7;
        }
    }

    .st-tab__chevron {
        font-size: 11px !important;
        margin-left: 2px;
        opacity: 0.7;
    }

    .st-tab__status {
        display: inline-flex;
        align-items: center;
        padding: 1px 6px;
        border-radius: 999px;
        font-size: 10px;
        font-weight: 600;
        line-height: 1.4;

        &--success {
            background: #DCFCE7;
            color: #16A34A;
        }

        &--warning {
            background: #FEF3C7;
            color: #D97706;
        }

        &--danger {
            background: #FEE2E2;
            color: #B91C1C;
        }
    }

    .st-menu {
        position: fixed;
        z-index: 1000;
        min-width: 220px;
        max-height: 320px;
        overflow-y: auto;
        padding: 6px;
        background: #fff;
        border: 1px solid #E7E7E7;
        border-radius: 12px;
        box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);
        display: flex;
        flex-direction: column;
        gap: 2px;
        animation: stMenuIn 140ms ease;

        @keyframes stMenuIn {
            from {
                opacity: 0;
                transform: translateY(-4px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }
    }

    .st-menu__item {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        padding: 8px 12px;
        border: none;
        background: transparent;
        color: var(--pei-text-label);
        border-radius: 8px;
        font-size: 13px;
        font-weight: 500;
        font-family: inherit;
        text-align: left;
        cursor: pointer;
        white-space: nowrap;
        transition: background 120ms ease, color 120ms ease;

        i {
            font-size: 13px;
            color: var(--pei-text-helper);
        }

        span {
            flex: 1;
        }

        &:hover:not(.is-current) {
            background: var(--pei-bg-soft);
        }

        &.is-current {
            background: rgba(50, 184, 223, 0.10);
            color: var(--pei-cyan);

            i {
                color: var(--pei-cyan);
            }
        }

        &:focus-visible {
            outline: none;
            box-shadow: 0 0 0 2px rgba(52, 198, 241, 0.25);
        }
    }

    .st-menu__check {
        font-size: 12px !important;
        color: var(--pei-cyan) !important;
        flex: 0 0 auto;
    }

    @media (prefers-reduced-motion: reduce) {
        .st-tab,
        .st-menu__item {
            transition: none;
        }

        .st-menu {
            animation: none;
        }
    }

    @media (max-width: 768px) {
        .st-tablist {
            padding: 5px;
            gap: 2px;
        }

        .st-tab {
            padding: 7px 10px;
            font-size: 12.5px;
        }
    }
`;
